import { createContext, useContext } from 'react';

interface CmsPageState {
  pageSlug: string;
}

const CmsPageContext = createContext<CmsPageState>({ pageSlug: '' });

export function useCmsPage(): CmsPageState {
  return useContext(CmsPageContext);
}

export { CmsPageContext };
